import type { GraphQLError } from 'graphql';

const parseError = (errorObj?: GraphQLError): string | undefined => {
  // This variable is only available in the local and QA
  const inputString = errorObj?.extensions?.debugMessage;
  if (typeof inputString === 'string') {
    return inputString;
  }
  return errorObj?.message;
};

export default parseError;
